import { useEffect, useRef } from "react";
import { UserDTO } from "../../../apiclients/bstinsights";
import { getSignalRConnection } from "../../../utils/signalRConnection";

export function useRealTimeUserUpdate(
  data: UserDTO[],
  setData: React.Dispatch<React.SetStateAction<UserDTO[]>>
) {
  // keep a mutable ref to the latest data array
  const dataRef = useRef<UserDTO[]>(data);
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  useEffect(() => {
    const conn = getSignalRConnection();
    const handler = (userId: number, updatedFields: UserDTO) => {
      // if that user is on screen, update just that one record
      if (!dataRef.current.some((u) => Number(u.userId) === userId)) {
        return;
      }
      setData((prev) =>
        prev.map((u) =>
          Number(u.userId) === userId ? { ...u, ...updatedFields } : u
        )
      );
    };

    conn.on("NotifyUserUpdated", handler);

    return () => {
      conn.off("NotifyUserUpdated", handler);
    };
  }, [setData]);
}
